import React from 'react';
import styled from 'styled-components/macro';
import Animation from '../Animation';
import {
  Delete as DeleteIcon,
  ExpandMore as ExpandMoreIcon
} from '@material-ui/icons';
import {
  IconButton,
  Tooltip,
  ExpansionPanel as MuiExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails
} from '@material-ui/core';
import DeleteDialog from '../../internal-components/GeneralDialog';
import Disabler from '../Disabler';

const Card = styled(Animation)`
  && {
    border: 1px solid #e0e0e0;
    margin: 0.8em;
    padding: 0.8em;
    min-height: 5em;
    border-radius: 10px;
    border-left: 20px solid ${props => (props.isActive ? '#1976d2' : '#e0e0e0')};
    position: relative;
  }

  [class*='Mui-expanded'] {
    margin: 0 !important;
    min-height: 30px !important;
  }
  [class*='MuiPaper-elevation1'] {
    box-shadow: none;
  }
  [class*='MuiExpansionPanelSummary-content'] {
    margin: 0 !important;
  }
  [class*='MuiExpansionPanelSummary-root'] {
    padding: 0;
  }
  [class*='MuiExpansionPanelSummary-root Mui-focused'] {
    background-color: #fff !important;
  }
  [class*='MuiExpansionPanelDetails-root'] {
    display: block;
    padding: 0;
  }
`;

const ExpansionPanel = styled(MuiExpansionPanel)``;

const ChildrenWrapper = styled.div`
  width: 100%;
  margin-bottom: 3em;
  text-align: left;
`;

const CardActionsWrapper = styled(Animation)`
  && {
    width: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: row-reverse;
    max-height: 3em;
    // margin: 0.8em;
    ${props => props.disabled && 'visibility: hidden;'}
  }
  svg {
    font-size: 1.1em;
  }

  button {
    margin: 0 0.2em 0 0;
  }
`;

const ActionsCardView = props => {
  const { actionButtons, deleteDialogProps } = props;

  return (
    <>
      <Card
        in={!props.isInDeleteSequence}
        onExited={props.onDelete}
        isActive={props.isActive}
        type="collapse"
        onMouseOver={() => props.setIsHoverd(true)}
        onMouseOut={() => props.setIsHoverd(false)}
        exit={!props.isInAnimatedConrainer}
        enter={!props.isInAnimatedConrainer}
      >
        <ExpansionPanel
          expanded={props.expanded}
          onChange={
            props.expandViaArrow
              ? () => {}
              : () => props.setExpanded(!props.expanded)
          }
        >
          {props.collapse && (
            <ExpansionPanelSummary
              expandIcon={
                <ExpandMoreIcon
                  onClick={() => props.setExpanded(!props.expanded)}
                />
              }
            >
              {props.collapseSummary}
            </ExpansionPanelSummary>
          )}
          <ExpansionPanelDetails>
            <Disabler
              onDisabledClick={props.onDisabledClicked}
              disabled={props.disabled}
            >
              <ChildrenWrapper>{props.children}</ChildrenWrapper>
            </Disabler>

            <CardActionsWrapper
              type="fade"
              playAnimation={props.isHovered || props.buttonsAlwaysVisible}
              disabled={props.disabled && !props.neverDisableActionButtons}
            >
              {props.onDelete && (
                <Tooltip title="Delete">
                  <IconButton
                    size="small"
                    onClick={() =>
                      props.useDeleteDialog
                        ? props.setIsDeleteDialogOpen(true)
                        : props.setIsInDeleteSequence(true)
                    }
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              )}
              {actionButtons &&
                actionButtons.map((actionButton, i) => {
                  let Icon = actionButton.icon;
                  return (
                    <Tooltip
                      title={actionButton.tooltip}
                      key={`actioncard-btn-${i}`}
                    >
                      <IconButton
                        data-testid={`action-${actionButton.internalName}-${props.title}`}
                        size="small"
                        onClick={actionButton.onAction}
                      >
                        <Icon />
                      </IconButton>
                    </Tooltip>
                  );
                })}
            </CardActionsWrapper>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Card>

      {props.useDeleteDialog && (
        <DeleteDialog
          open={props.isDeleteDialogOpen}
          title="dialog.title.areYouSure"
          content="dialog.delete.content.general"
          variant="delete"
          handleClose={() => props.setIsDeleteDialogOpen(false)}
          handleConfirm={() => {
            props.setIsDeleteDialogOpen(false);
            props.setIsInDeleteSequence(true);
          }}
          {...deleteDialogProps}
        />
      )}
    </>
  );
};

export default ActionsCardView;
